import Brand from './Models/Brand'

Vue.prototype.$models.$brand = new Vue(Brand)

Vue.component('brands-table', () => import(/* webpackChunkName: "brands-table" */ '@modulesPages/Brand/Resources/assets/js/Tables/BrandsTable'))

Vue.component('brands-form', () => import(/* webpackChunkName: "brands-form" */ '@modulesPages/Brand/Resources/assets/js/Forms/Brands/BrandsForm'))

Vue.component('brands-card', () => import(/* webpackChunkName: "brands-card" */ '@modulesPages/Brand/Resources/assets/js/Cards/BrandsCard'))

Vue.component('brands-section', () => import(/* webpackChunkName: "brands-section" */ '@modulesPages/Brand/Resources/assets/js/Sections/BrandsSection'))
Vue.component('brand-section', () => import(/* webpackChunkName: "brand-section" */ '@modulesPages/Brand/Resources/assets/js/Sections/BrandSection'))

Vue.component('brand-selector', () => import(/* webpackChunkName: "brand-selector" */ '@modulesPages/Brand/Resources/assets/js/Components/BrandSelector'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Brand\\Entities\\Brand': 'Marca',
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Brand\\Entities\\Brand': 'Brands',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'brands': 'Modules\\Brand\\Entities\\Brand',
	}	
}